exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".-pJvQw8WCSS64u4yeesBP{color:#e81123}html[dir] .-pJvQw8WCSS64u4yeesBP{padding-top:8px}html[dir=ltr] .-pJvQw8WCSS64u4yeesBP{padding-left:5px}html[dir=rtl] .-pJvQw8WCSS64u4yeesBP{padding-right:5px}.-pJvQw8WCSS64u4yeesBP:hover{color:\"[theme:redDark, default:#a80000]\"}", ""]);
// Exports
exports.locals = {
	"errorIcon": "-pJvQw8WCSS64u4yeesBP"
};